


export default {
    head() {
        
        return {
            title: `ICFA - Nos actualités - ${this.news.attributes.titleText}`,
            meta: [
                {
                    hid: 'title',
                    property: 'title',
                    content: `Nos actualités - ${this.news.attributes.titleText}`,
                },
                {
                    hid: 'description',
                    property: 'description',
                    content: this.news.attributes.titleText,
                }
            ]
        };
    },
    data() {
    },
    methods: {

    },


    async asyncData({ params, $http, store, redirect }) {
        // let instances = await $http.$get(`${process.env.strapiBaseUri}/api/instances`);
        // instances = instances.data;
        let instances = store.state.instances;

        let newsID = params.news.split('-').slice(-1)[0]
        let news;
        try {
            news = await $http.$get(`${process.env.strapiBaseUri}/api/news-generales/${newsID}?populate=imageGenerale,createdBy,campus`);
            news = news.data
        } 
        catch(error) {
            // redirect to lost page
            redirect('/404-error/')
        }
        let imageGeneraleURL = process.env.strapiBaseUri + news.attributes.imageGenerale?.data?.attributes?.url;
        
        let campusBanier = await $http.$get(`${process.env.strapiBaseUri}/api/${news.attributes.campus.data.attributes.prefix}-home-page?populate=banniereLogo`);
        campusBanier = campusBanier.data;

        let campusBanierLogo = process.env.strapiBaseUri + campusBanier.attributes.banniereLogo?.data?.attributes?.url;



        return { instances, params, news, campusBanier, campusBanierLogo, imageGeneraleURL }
    },

}
